export const queryKeys = {
  SOCIAL_NETWORK_URLS: 'SOCIAL_NETWORK_URLS'
};
